import { TFunction } from "i18next";
import { GenericFormFields } from "../../../generic-form/GenericFormBody";

export const saveTakeOffAsTemplateFields = (
  t: TFunction
): GenericFormFields<{ name: string }> => {
  return {
    name: {
      type: "text",
      label: t("takeOffSection.templateName"),
      placeholder: t("takeOffSection.templateName"),
      valueKey: "name",
      showError: true,
      inputProps: {},
    },
  };
};
